import { createAction } from 'redux-actions';

// ------------------------------------
// Actions
// ------------------------------------
export const getLocationsHash: any = createAction('locations/GET_LOCATIONS_HASH', (locations: State.Location) => () => {
  return locations;
});
